import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { IoClose } from "react-icons/io5";
import MainContentList from "components/main-content/MainContentList";

const defaultCategories = [
  { label: "Քաղաքական", value: "politic" },
  { label: "Սոցիալական", value: "social" },
  { label: "Տնտեսական", value: "economic" },
  { label: "Մարգարեական", value: "prophetic" },
  { label: "Ֆինանսական", value: "finance" },
  { label: "Սպորտային", value: "sport" },
  { label: "Գիտական", value: "scientific" },
];

const MainContentDialog = ({
  items,
  selectedItems,
  setSelectedItems,
  open,
  onClose,
  isLoading,
  getNextPage,
  page,
  setPage,
  hasMoreItems,
  label,
  category,
  setCategory = () => {},
  categories = defaultCategories,
  cardComponent,
}) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: "#f8fafc",
        },
      }}
    >
      {/* Modern Dialog Header */}
      <div className="bg-white border-b border-slate-200/80 px-6 py-4 flex items-center justify-between shadow-xs sticky top-0 z-50">
        <div>
          <h2 className="text-lg font-bold text-slate-900">
            Ընտրել «{label}» գլխավոր էջի համար
          </h2>
          <p className="text-xs text-slate-500 mt-0.5">
            Սեղմեք քարտերի վրա՝ դրանք ավելացնելու կամ հեռացնելու համար (ներկայումս ընտրված է {selectedItems.length})
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-xl text-xs font-semibold bg-indigo-600 hover:bg-indigo-700 text-white transition shadow-xs cursor-pointer"
          >
            Պահպանել և Փակել
          </button>
          <button
            type="button"
            onClick={onClose}
            className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-xl transition cursor-pointer"
            title="Փակել"
          >
            <IoClose size={22} />
          </button>
        </div>
      </div>

      <DialogContent style={{ padding: 0, backgroundColor: "#f8fafc" }}>
        <MainContentList
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          items={items}
          isLoadingNextPage={isLoading}
          hasMoreItems={hasMoreItems}
          getNextPage={getNextPage}
          page={page}
          setPage={setPage}
          cardComponent={cardComponent}
        />
      </DialogContent>
    </Dialog>
  );
};

export default MainContentDialog;
